import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // model
  screenModel: [],

  //form
  serviceId: null,
  serviceContentsId: null,
  serviceTypeCd: null,

  buttonId: null,
  index: 0,

  // 選択されたファイル情報
  value: null,

  // モーダルに重ねて表示する場合true
  overlay: false,
}

const getters = {
	get: state => state,

  // contentsScreenUuidから画面名を取得
  getScreenName: state => screenCode => {
    try {
      console.log('screenModel', state.screenModel)
      return state.screenModel.filter(item => item.screenCode === screenCode)[0].screenName
    // eslint-disable-next-line
    } catch (e) {
      return ''
    }
  }
}

const actions = {
	show ({commit}, {serviceId, serviceContentsId, serviceTypeCd, buttonId, index, overlay}) {
		// cover
		this.dispatch('core/showModalCover')
		
    commit('setServiceId', serviceId)
    if (serviceContentsId !== undefined) {
      commit('setServiceContentsId', serviceContentsId)
    }
    if (serviceTypeCd !== undefined) {
      commit('setServiceTypeCd', serviceTypeCd)
    }
    commit('setButtonId', buttonId)
    if (index !== undefined) {
      commit('setIndex', index)
    }

    if (overlay === undefined) {
      commit('setOverlay', false)
    } else {
      commit('setOverlay', overlay)
    }

		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
    if (state.overlay) return

		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceContentsParams}) {
    if (serviceContentsParams.serviceContentsUuid) {
      commit('setServiceContentsId', serviceContentsParams.serviceContentsUuid)
    }
    
    return new Promise((resolve, reject) => {
      // サービスコンテンツ基本設定の新規登録の場合は
      // 基本設定で選択されたサービスコードを引き継いで固定画面のみ選択可能にする
      if (state.serviceContentsId === Constants.RegisterHash) {
        const screenIdMstParams = {
          filters: {
            serviceTypeCd: state.serviceTypeCd
          }
        }

        // サービスコンテンツの画面一覧と固定画面一覧を読み出し
        ApiManager.request(
          ['screenIdMst',],
          ['v1ScreenIdMstListGet',],
          [screenIdMstParams,])
          .then(res => {
            let status = Utility.parseResponse(res)

            if (status.result) {
              commit('setFixScreenModel', res)
              console.log('screenModel', state.screenModel)
              resolve()

            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })

      } else {
        // サービスコンテンツ基本設定の編集の場合は
        // 基本設定で選択されたサービスコードを引き継いで
        // サービスコンテンツに属する画面と固定画面から選択可能にする
        if (state.serviceTypeCd !== null) {
          const screenIdMstParams = {
            filters: {
              serviceTypeCd: state.serviceTypeCd
            }
          }

          // サービスコンテンツの画面一覧と固定画面一覧を読み出し
          ApiManager.request(
            [
              'serviceContentsSetting',
              'screenIdMst',
            ],
            [
              'v1ServiceContentsSettingRelationalDetailGet',
              'v1ScreenIdMstListGet',
            ],
            [
              serviceContentsParams,
              screenIdMstParams,
            ])
            .then(res => {
              console.log(res)
              let status = Utility.parseResponse(res)

              if (status.result) {
                commit('setScreenModel', res)
                console.log('screenModel', state.screenModel)
                resolve()

              } else if (status.error) {
                // エラーメッセージ表示
                reject(res)
              } else {
                // アプリケーションエラー表示
                reject(null)
              }
            })
            .catch(error => {
              // アプリケーションエラー表示
              reject(null)
            })


        // 画面別編集の場合は
        // サービスコンテンツ基本設定情報からサービスコードを取得し
        // サービスコンテンツに属する画面と固定画面から選択可能にする
        } else {
          ApiManager.request(
            ['serviceContentsSetting'],
            ['v1ServiceContentsSettingDetailGet'],
            [serviceContentsParams])
            .then(res => {
              let status = Utility.parseResponse(res)

              if (status.result) {
                // 指定されたserviceContentsIdからserviceTypeCdを取得
                const serviceTypeCd = res[0].data.serviceContentsSettings.contentsBasicSetting.serviceTypeCd
                const screenIdMstParams = {
                  filters: {
                    serviceTypeCd: serviceTypeCd
                  }
                }

                // サービスコンテンツの画面一覧と固定画面一覧を読み出し
                ApiManager.request(
                  [
                    'serviceContentsSetting',
                    'screenIdMst',
                  ],
                  [
                    'v1ServiceContentsSettingRelationalDetailGet',
                    'v1ScreenIdMstListGet',
                  ],
                  [
                    serviceContentsParams,
                    screenIdMstParams,
                  ])
                  .then(res => {
                    console.log(res)
                    let status = Utility.parseResponse(res)

                    if (status.result) {
                      commit('setScreenModel', res)
                      console.log('screenModel', state.screenModel)
                      resolve()

                    } else if (status.error) {
                      // エラーメッセージ表示
                      reject(res)
                    } else {
                      // アプリケーションエラー表示
                      reject(null)
                    }
                  })
                  .catch(error => {
                    // アプリケーションエラー表示
                    reject(null)
                  })

              } else if (status.error) {
                // エラーメッセージ表示
                reject(res)
              } else {
                // アプリケーションエラー表示
                reject(null)
              }
            })
            .catch(error => {
              // アプリケーションエラー表示
              reject(null)
            })
        }
      }
    })
  },

  /**
   * 選択されたファイル情報を保持
   */
  setValue ({commit}, data) {
    commit('setValue', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  // 固定画面のmix
  setFixScreenModel (state, data) {
    let list = []

    // 固定画面を追加
    data[0].data.screenIdMsts.forEach(item => {
      if (item.screenTransitionFlg) {
        list.push({
          contentsScreenId: item.screenId,
          contentsScreenUuid: item.screenIdMstUuid,
          screenCode: item.screenId,
          isReleased: 1,
          screenName: item.screenName
        })
      }
    })

    Vue.set(state, 'screenModel', list)
  },
  // サービスコンテンツに属する画面と、固定画面のmix
  setScreenModel (state, data) {
    let list = []

    // 指定されたサービスコンテンツの画面に絞り込む
    data[0].data.serviceContentsSettings
      .filter(content => content.serviceContentsUuid === state.serviceContentsId)
      .forEach(content => {
        if (content.contentsScreenSettings &&
          content.contentsScreenSettings.length) {
          content.contentsScreenSettings.forEach(screen => {
            if (screen.screenSettings &&
              screen.screenSettings.screenNameSetting) {
              list.push({
                contentsScreenId: screen.contentsScreenId,
                contentsScreenUuid: screen.contentsScreenUuid,
                screenCode: screen.screenSettings.screenNameSetting.screenCode,
                // screenCode: screen.contentsScreenUuid,
                screenName: screen.screenName,
                // screenName: content.contentsName + ' : ' + screen.screenName,
                isReleased: screen.isReleased
              })
            }
          })
        }
      })

    // 「画面遷移対応：あり」の固定画面を追加
    data[1].data.screenIdMsts.forEach(item => {
      if (item.screenTransitionFlg) {
        list.push({
          contentsScreenId: item.screenId,
          contentsScreenUuid: item.screenIdMstUuid,
          screenCode: item.screenId,
          isReleased: item.screenIdStatus,
          screenName: item.screenName
        })
      }
    })

    Vue.set(state, 'screenModel', list)
  },
  
  // form
  setServiceId (state, id) {
    state.serviceId = id
  },
  setServiceContentsId (state, id) {
    state.serviceContentsId = id
  },
  setServiceTypeCd (state, code) {
    state.serviceTypeCd = code
  },

  setButtonId (state, id) {
    state.buttonId = id
  },
  setIndex (state, index) {
    state.index = index
  },
  setValue (state, data) {
    Vue.set(state, 'value', data)
  },

  // overlay
  setOverlay (state, flag) {
    state.overlay = flag
    console.log('actions', flag)
  },

  // reset
  reset (state) {
    Vue.set(state, 'screenModel', [])
    Vue.set(state, 'value', null)
    // state.overlay = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
